<template>
  <div class="marginCenter">
<!-- <video id="myAudio" src="./mp3.mp3" controls="controls" hidden="hidden"></video> -->
    	<div class="viewBox">
			<p class="back" @click="back">返回上一页</p>
       <h3 style="margin-top: 20px;">线下保单查询</h3>
       <div class="searchBox">
      <div class="block">
        被保人
        <!-- <el-date-picker v-model="startTime" value-format="timestamp" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" size="mini">
        </el-date-picker> -->
        <el-input class='width' placeholder="请输入被保人" size="mini" v-model="insuredName"></el-input>
      </div>
      <div class="block">
        证件类型
        <el-select style="height:28px" v-model="idType" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="block">
        证件号
        <el-input class='width' placeholder="请输入证件号" size="mini" v-model="nationalId"></el-input>
      </div>
      <div class="block">
        保单号/投保单号
        <el-input class='width' placeholder="请输入保单号/投保单号" size="mini" v-model="policyNo"></el-input>
      </div>
      <div class="block">
        保险公司
        <el-select style="height:28px" v-model="companyId" placeholder="请选择">
          <el-option
            v-for="item in options1"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="block">
        <el-button type="primary" @click="seegetdata(1)" size="mini">查询</el-button>
      </div>
       <div class="block">
        <el-button type="primary" @click='centerDialogVisible3=true;' size="mini">导入</el-button>
      </div>

      	<a class="yellow" href="http://f.dajiuxing.com.cn/other/offline_insurance_template.xlsx">(下载模板)</a>
    </div>
    	<el-dialog title="上传附件" :visible.sync="centerDialogVisible3" width="500" center>
			<el-upload class="upload-demo"
			 action="aaa"
			 :on-preview="handlePreview"
			 :on-remove="handleRemove"
			 :before-remove="beforeRemove"
			 :http-request="requestFile"
			 :limit="1"
			 :on-exceed="handleExceed"
			 :before-upload="beforeAvatarUpload"
			 ref="upload"
			 :file-list="fileList1">
				<el-button size="small" type="primary">点击上传</el-button>
				<div slot="tip" class="el-upload__tip">只能上传xlsx文件</div>
        <div style="color:red;margin-top: 10px;">注：单次上传只能添加1000条以内文件</div>
			</el-upload>
			<span slot="footer" class="dialog-footer1">
				<el-button class='btn' @click="centerDialogVisible3 = false">取 消</el-button>
				<el-button class='btn' type="primary" @click="addList()">确 定</el-button>
			</span>
		</el-dialog>
    <div class="table">
      <table width="100%" border="0" cellpadding="0" cellspacing="0">
        <thead>
          <tr>
            <th v-for="item in tableName">{{item}}</th>
          </tr>
        </thead>
        <tbody v-if="zxList.length != 0">
          <tr v-for="(item,index) in zxList">
            <!-- <td>{{index + 1}}</td> -->
            <td>{{ item.issureApplicant }}</td>
            <td>{{ item.policyNo }}</td>
            <td>{{ item.productName }}</td>
            <td>{{ formattingTime(item.validFrom) }}</td>
            <td>{{ formattingTime(item.validUtil) }}</td>
            <td>{{ formattingTime(item.issureTime) }}</td>
            <td v-text="item.companyCode == 8 ? '亚太财险' : item.issureOrderChannel"></td>
            <td>{{ item.insuredName }}</td>
            <td>{{ item.nationalId }}</td>
            <td>{{ item.targetCountry }}</td>
            <td>{{ item.issuredType }}</td>
            <td>{{ item.validDays }}</td>
            <td v-text="item.status == 2 ? '退保' : '-'"></td>
            <td>
              <div style="padding:0px 15px;color: blue;cursor:pointer;" @click="deleteclick1(item.id)">删除</div>
            </td>
          </tr>
        </tbody>

      </table>
      <p v-if="zxList.length == 0" class="noRecord">暂无记录</p>
    </div>
    
    <el-pagination
    style="margin-top: 20px;float: right;"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage4"
      :page-sizes="[50]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>

<el-dialog
  title="提示"
  :visible.sync="dialogVisible"
  width="30%"
  >
  <span>确定删除？</span>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="deleteclick()">确 定</el-button>
  </span>
</el-dialog>

		</div>
  </div>
</template>

<script>
import axios from 'axios'
import canAutoPlay from 'can-autoplay';
  import {
    rescue_offlineinsurelist,
    rescue_offlineinsuredel,
    rescueoffline_insurequery
  } from '@/views/axios/api.js';
   import constants from "@/util/constants.js"
  export default {
    data() {
      return {
        companyId:'',
        options1:[
        {
          value: '100',
          label: '众惠'
        }, {
          value: '0',
          label: '其他'
        }
        ],
        idType:'',
        options: [{
          value: '1',
          label: '身份证'
        }, {
          value: '2',
          label: '护照'
        }],
        speech: null,
        i:0,
        insuredName:'',
        start:1,
        total:0,
        form:"",
        config:{},
        fileList1:[],
        nationalId:'',
        policyNo:'',
        centerDialogVisible3:false,
        dialogVisible:false,
       tableName: [ '投保人', '保单号/投保单号', '产品名称', '保险起期', '保险止期', '投保时间', '所属保险公司分公司', '被保人','身份证号码','目的地国家','被保险职业类别','保险天数','状态','操作'],
        zxList: [],
        currentPage4: 1,
        token: this.$route.params.token ||
					JSON.parse(window.localStorage.getItem("data")).data,
        play:false
      }
    },
    created(){
      
    },
    mounted() {
      // console.log(this.token)
      // 	setInterval(() => {
      //     this.audioAutoPlay()
      //     }, 5000);
      
      this.getdata()
    },
    methods: {
    // audioAutoPlay() {
    //   var that = this;
    //    canAutoPlay.audio().then(({ result }) => {
    //     //支持自动播放
    //     if (result === true) {
    //       console.log('叮叮当')
    //       that.autoplay();
    //     } else {
    //       this.$alert(
    //         "检测到您的浏览器不支持媒体自动播放，是否同意播放音频",
    //         "提示",
    //         {
    //           confirmButtonText: "确定",
    //           callback: (action) => {
    //             that.autoplay();
    //           },
    //         }
    //       );
    //     }
    //   });
    // },
    // autoplay(){
    //   if (this.play == true) {
    //     var audio1 = document.getElementById("myAudio");
    //     setTimeout(() => {
    //       audio1.play()
    //     },500)
    //   } else {
    //     this.play = true;
    //   }
    // },
      addList() {
	axios.post(SEVSRS + '/spring/rescue/offline_insure/online_import', this.form, this.config)
					.then(res => {
            
            console.log()
            if(res.data.code == 10000101) {
               this.$message.error('数据有错，请核对');
            }else if(res.data.code == 105007) {
               this.$message.error('单次上传不能超过1000条，请核对');
              }else if(res.data.code == 0){
               this.centerDialogVisible3 = false
               this.fileList1=[]
               this.getdata()
               this.$message({
				  		 type: 'success',
					  	 message: '导入成功！'
						});
            }else {
              	this.$message({
                type: 'success',
                message: res.data.msg
              });
            }
						// if (res.data.code == 100000 || res.data.code == 0) {
						// 	this.fileList2 = res.data.obj;
						// 	this.fileList2.forEach(item => {
						// 		item.mobileno = Number(item.mobileno)
						// 	})
						// 	this.fileList2.forEach( item => {
						// 		if(this.setIdFun1(item.nationalId)){
						// 			item.birthday=this.setIdFun1(item.nationalId).getTime()
						// 		}
						// 	})

						// }else if(res.data.code == 101000){
						// 	this.$message.warning('token失效，请重新登录！')
						// 	this.$router.push({
						// 		path:'/login'
						// 	})
						// }
					})
					.catch(err => {
						console.log(err)
					})
      },
      	beforeRemove(file, fileList) {
				// return this.$confirm(`确定移除 ${ file.name }？`);
			},
			beforeAvatarUpload(file) {
				// 文件类型进行判断
				console.log(file)
				// const isxlsx = file.name === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
				const reg =/.xlsx$/
				const isxlsx = file.name.search(reg) > 0

				if (!isxlsx) {
					this.$message.error("上传只能是xls格式!");
				}
				return isxlsx
			},
      	handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handlePreview(file) {
				console.log(file);
			},
      	handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
	requestFile(param) {
				var fileObj = param.file
				let config = {
					headers: {
						"Content-Type": "multipart/form-data"
					}
				};
				var form = new FormData() // FormData 对象
				form.append('file', fileObj) // 文件对象
				var token = this.token
				form.append('token', token) // 文件对象
        this.config = config
        this.form = form
			
			},

       formattingTime(time) {
        return constants.time(time)
      },
      deleteclick1(item) {
       this.id = item
       this.dialogVisible = true
      },
       handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        // this.start = (val-1) * 10
        this.start = val
          this.seegetdata(2)
        console.log(`当前页: ${val}`);
      },
      deleteclick(){
        rescue_offlineinsuredel({ids:this.id,token:this.token}).then((res)=>{
          console.log(res)
          if(res) {
           this.dialogVisible = false
           this.$message({
          message: '删除成功',
          type: 'success'
        });
           this.getdata()
          }     
        })
       console.log(item)
      },
      getdata() {
        var obj = {
          token:this.token,
          // state: 110,
          pageNum: this.start,
          pageSize: 50,
          // insuredName:this.insuredName,
          // policyNo:this.policyNo,
          // nationalId:this.nationalId
          }
        rescue_offlineinsurelist(obj).then((res)=>{
         console.log(res)
          this.zxList = res.data.data
          this.total = res.data.total
       
        })
      },
    back(){
				this.$router.go(-1)
			},
       seegetdata(type) {
          // 
         if(this.insuredName == '' && this.policyNo =='' && this.nationalId == "" && this.companyId == "" && this.idType == "") {
          this.getdata()
         }else {
            if(type == 1) {
              this.currentPage4= 1,
               this.start = 1
            }
            var obj = {
          token:this.token,
          // state: 110,
          companyId:this.companyId,
          idType:this.idType,
          pageNum: this.start,
          pageSize: 50,
          insuredName:this.insuredName,
          policyNo:this.policyNo,
          nationalId:this.nationalId
          }
         rescueoffline_insurequery(obj).then((res)=>{
            this.zxList = res.data.data
          this.total = res.data.total
         })
         }
     
         
        //  
      },
    },
     
    watch: {
    
    }
  }
</script>

<style scoped="scoped">
/deep/.el-input--suffix {
  height: 28px !important;
}
/deep/.el-input--suffix .el-input__inner {
  height: 28px !important;
}
  .marginCenter {
        width: 95%;
    margin: 20px auto 0;
    position: relative;
    padding-top: 20px;
    background-color: #fff;
    text-align: start;
  }
  .marginCenter .viewBox{float: left;width:100%;background: white;padding: 20px;box-sizing: border-box;}
.back{background: url(./img/back.png) left center no-repeat;padding-left: 20px;background-size: 15px;cursor: pointer;}
.searchBox {
    margin-top: 20px;
  }

  .zixunBox h3 {
    margin-top: 20px;
  }

  .table {
    margin-top: 30px;
    border: 1px solid #d9ddde;
    border-right: none;
    border-bottom: none;
  }

  .table thead {
    background: #f5f7fb;
    color: #333;
  }

  .table th {
    font-size: 14px;
    color: #333;
    height: 50px;
    border-bottom: 1px solid #d9ddde;
    border-right: 1px solid #d9ddde;
  }

  .table td {
    border-bottom: 1px solid #d9ddde;
    border-right: 1px solid #d9ddde;
    text-align: center;
    font-size: 12px;
    height: 50px;
    word-wrap: break-word;
    padding: 0 5px
  }

  .table a {
    text-decoration: none;
    color: #00abfa;
    padding: 0 5px;
    cursor: pointer;
  }

  .noRecord {
    text-align: center;
    line-height: 100px;
    border-right: 1px solid #d9ddde;
    color: #666;
    border-bottom: 1px solid #d9ddde;
  }

  .searchBox {
    margin-top: 20px;
  }

  .searchBox>div {
    display: inline-block;
    margin-right: 20px;
  }

  .width {
    width: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/views/cmd_center/monitoringCase/Offlinepolicy.vue